import React from "react";
import PropTypes from "prop-types";
import { BLOCKS, INLINES } from "@contentful/rich-text-types";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { FluidSections } from "../FluidSections";
import { LinkConnector } from "../LinkConnector";

const RichTextConnector = ({ className, listClassName, data }) => {
	const renderComponents = entry => {
		const fields = data?.references?.find(i => i.contentful_id === entry?.sys?.id);
		if (!fields) {
			return null;
		}

		return <FluidSections data={[fields]} useWrapper={false} />;
	};

	const options = {
		renderNode: {
			[INLINES.HYPERLINK]: ({ data: richtextData }, children) => (
				<LinkConnector to={richtextData.uri} target={null}>
					{children}
				</LinkConnector>
			),
			[BLOCKS.UL_LIST]: (node, children) => <ul className={listClassName}>{children}</ul>,
			[BLOCKS.EMBEDDED_ENTRY]: (node, children) =>
				!!renderComponents && <div>{renderComponents(node?.data?.target, children)}</div>,
			[INLINES.EMBEDDED_ENTRY]: (node, children) =>
				!!renderComponents && renderComponents(node?.data?.target, children),
		},
		renderText: text =>
			text.split("\n").reduce(
				(children, textSegment, index) => [
					...children,
					// eslint-disable-next-line react/no-array-index-key
					index > 0 && <br key={index} />,
					textSegment,
				],
				[]
			),
	};
	return (
		<div className={className}>
			{documentToReactComponents(data?.raw ? JSON.parse(data?.raw) : data?.json, options)}
		</div>
	);
};

RichTextConnector.propTypes = {
	className: PropTypes.string,
	listClassName: PropTypes.string,
	data: PropTypes.object.isRequired,
};

RichTextConnector.defaultProps = {
	className: undefined,
	listClassName: undefined,
};

export { RichTextConnector };
